import * as schemas from '@gogame/schemas';

export const labelsValidationSchema = schemas.object({
  name: schemas.string().required('Name is required'),
  color: schemas.string().required('Color is required'),
});
